import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface CreateInfestationReportPayload {
  id?: string
  company: { id: number; name: string }
  requester: { id: number; name: string; email: string }
  weed_type_by_culture: { [key: string]: string[] }
  initial_conclusion_date: string
  final_conclusion_date: string
  ordered_by: string
}

export interface CreateInfestationReportResponse {
  id: string
  name: string
  created_at: string
  status: { label: string; status_key: string }
  requester: { id: number; name: string; email: string }
  report_type: 'infestation'
  company: { id: number; name: string }
  weed_type_by_culture: { [key: string]: string[] }
  initial_conclusion_date: string
  final_conclusion_date: string
  ordered_by: string
}

export async function createInfestationReport(
  newReport: CreateInfestationReportPayload,
  config?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.post<CreateInfestationReportResponse>(
    apiRoutes.getInfestationReports,
    newReport,
    config,
  )

  return data
}
